import React from 'react';
import { motion } from 'framer-motion';

const ReportPage = ({ pageNumber, title, children }) => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      className="bg-white min-h-[1100px] w-full max-w-[800px] mx-auto shadow-2xl mb-12 p-16 flex flex-col border border-slate-100 relative group"
    >
      {/* Brevhode-simulering */}
      <div className="flex justify-between items-start mb-16 border-b pb-8 border-slate-50">
        <div>
          <div className="flex items-center gap-2 mb-2">
            <div className="w-8 h-8 bg-slate-900 rounded-lg flex items-center justify-center text-white font-black text-xs">HI</div>
            <span className="text-[10px] font-black uppercase tracking-[0.2em] text-slate-900">HMS-innsikt</span>
          </div>
          <p className="text-[9px] font-bold text-slate-400 uppercase tracking-widest">Organisasjonsrapport 2024</p>
        </div>
        <div className="text-right">
          <p className="text-[9px] font-black text-slate-900 uppercase tracking-widest">{title}</p>
          <p className="text-[9px] font-bold text-slate-400 mt-1 uppercase">Konfidensielt</p>
        </div>
      </div>

      {/* Innhold */}
      <div className="flex-1">
        {children}
      </div>

      {/* Sidetall */}
      <div className="mt-16 pt-8 border-t border-slate-50 flex justify-between items-center text-[9px] font-black text-slate-400 uppercase tracking-widest">
        <span>© 2024 HMS-innsikt AS</span>
        <span>Side {pageNumber}</span>
      </div>
    </motion.div>
  );
};

export default ReportPage;